"use client";

import StatusBar from "@portal/components/atoms/statusBar";
import Typography from "@portal/components/atoms/v2/typography";
import usePortalMessage from "@portal/hooks/usePortalMessage";

const PortalMessage = () => {
  const { data: portalMessage } = usePortalMessage();

  if (!portalMessage?.enabled) {
    return null;
  }

  return (
    <div className="print:hidden">
      <StatusBar>
        <div className="flex">
          <Typography variant="Body">{portalMessage.message}</Typography>
        </div>
      </StatusBar>
    </div>
  );
};

export default PortalMessage;
